module.exports = __webpack_public_path__ + "img/04.b332eed9.png";